import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * 我们自己的字号名（CR-083，定义在 index.css）。**加字号要加在这里**。
 *
 * tailwind-merge 只认识 text-xs / text-sm 这些内置字号，不认识的 `text-xxx` 一律当成颜色 ——
 * 于是 `cn('text-figure', 'text-danger')` 会把字号当成被后面的颜色覆盖掉、整个删了，
 * 那段字回落到正文字号（CR-083 之前是浏览器默认的 16px）。不报错，只是「有些地方字不对」。
 */
export const FONT_SIZES = ['micro', 'caption', 'body', 'input', 'title', 'heading', 'figure'] as const;

const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: [...FONT_SIZES] }] } },
});

/**
 * 合并 class 名。
 *
 * `twMerge` 做的是**后面的赢**：`cn('px-4', 'px-6')` 得到 `px-6`，
 * 而不是两个都留着让浏览器按 CSS 顺序猜。组件允许调用方传 className
 * 覆盖默认样式，没有它就会出现「我传了 px-6 但没生效」这种查半天的问题。
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
